import { confirmEmailCode, sendEmailChallenge } from '@client/new/api/auth.api';
import { useSignUpStore } from '@client/new/stores/sign-up.store';
import { navigate, PATHS } from '@client/routes';
import { useCallback, useState } from 'react';
import { toast } from 'react-hot-toast';
import { CodeConfirmation } from '../code-confirmation';
import { useSignUp } from './useSignUp';
import * as React from 'react';
import { F0 } from '@client/new/helpers/types';

export const RegistrationConfirmationCodePage = () => {
  const [loading, setLoading] = useState(false);
  const { email, setToken } = useSignUpStore();
  const { register, login } = useSignUp();
  React.useEffect(() => {
    sendEmailChallenge(email).catch(() => toast.error('Something went wrong'));
  }, []);

  const verifyCode = useCallback(
    async (code: string, onError: F0) => {
      setLoading(true);
      confirmEmailCode(email, code)
        .then(({ user, token }) => {
          if (!token) {
            throw new Error('Invalid code');
          }

          if (user) {
            // if user by mistake tries to signup again, login him
            login(user);
            return navigate(PATHS.HOME);
          }
          register(token);
        })
        .catch((err) => {
          console.log('err', err);
          toast.error('Invalid code');
          onError();
        })
        .finally(() => {
          setLoading(false);
        });
    },
    [email, login, setToken],
  );

  if (!email) {
    return navigate(PATHS.LOGIN);
  }

  return (
    <CodeConfirmation
      email={email}
      verifyCode={verifyCode}
      isVerifying={loading}
    />
  );
};
